<template>
  <v-card class="bordered-card">
    <v-toolbar class="grey lighten-4 elevation-0">
      <v-toolbar-title class="grey--text text-underline text--darken-4">
        Activity Stream
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-switch class="rss-feed-switch" label="RSS Feed" style="width: 120px;padding-top: 17px;" v-model="toogleRssFeedSchedule"></v-switch>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-title>
      <v-flex xs2 class="mr-4">
        <v-card flat>
          <v-select :items="status_filter" v-model="currentStatus" label="Status" single-line bottom></v-select>
        </v-card>
      </v-flex>
      <v-flex xs2 class="mr-4">
        <v-card flat>
          <v-select :items="default_filter" v-model="dateRange" label="Date Range" single-line bottom></v-select>
        </v-card>
      </v-flex>
      <v-flex xs3 class="activity-search">
        <v-card flat>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card>
      </v-flex>
    </v-card-title>
    <v-data-table :headers="headers" :items="feeds" v-bind:search="search" :pagination.sync="pagination"
      :rows-per-page-items="[15, 25, 50, 100]">
      <!-- <template slot="headers" scope="props">
      <tr>

              <th v-for="header in props.headers" :key="header.text"
                  :class="[pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
              >
                {{ header.text }}
              </th>
              <th>
                Actions
              </th>
            </tr>
          </template> -->
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.posteddate | actualDate }}</td>
        <td class="text-xs-left">
          <div class="avatar ml-2" style="height: 24px; width: 24px;">
            <img :src="returnLogo(props.item.avatar)">
          </div>
          {{ props.item.user.firstname }} {{ props.item.user.lastname }}
        </td>
        <td class="text-xs-left">
          {{ props.item.user.company.companylegalname }}
        </td>
        <td class="text-xs-left">{{ props.item.content | sliceText }}</td>
        <td class="text-xs-left">{{ props.item.approvalStatus | status }}</td>
        <td class="text-xs-left">
          <v-layout row>
            <v-flex xs3 sm3>
              <v-tooltip top>
                <v-btn @click.prevent="changeStatus(1, props.item.id)" slot="activator" :disabled="props.item.approvalStatus === 1"
                  icon class="green--text">
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Approve</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs3 sm3>
              <v-tooltip top>
                <v-btn @click.prevent="changeStatus(2, props.item.id)" slot="activator" :disabled="props.item.approvalStatus === 2"
                  icon class="red--text">
                  <v-icon>clear</v-icon>
                </v-btn>
                <span>Reject</span>
              </v-tooltip>
            </v-flex>
            <v-flex xs3 sm3>
              <v-dialog v-model="props.item.activeDialog" lazy absolute max-width="790px">
                <v-btn slot="activator" icon class="blue--text">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
                <v-card>
                  <v-layout row>
                    <v-flex xs12 sm12>
                      <v-toolbar color="white" prominent>
                        <v-toolbar-title class="body-2 grey--text">Post Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                          <v-btn slot="activator" class="red--text darken-1" icon @click.native="props.item.activeDialog = false">
                            <v-icon>clear</v-icon>
                          </v-btn>
                          <span>Close</span>
                        </v-tooltip>
                      </v-toolbar>
                      <v-divider></v-divider>
                      <v-list two-line dense class="pa-3">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ props.item.user.firstname + ' ' + props.item.user.lastname}}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ props.item.user.jobtitle }} <span v-if="props.item.user.jobtitle">|</span>
                            {{ props.item.user.company.companylegalname }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list>
                      <v-card-text v-if="!props.item.type">{{ props.item.content }}</v-card-text>
                      <v-card-text v-if="props.item.type && props.item.type === 'rss'">
                        <b>{{ props.item.title }}</b>
                        <div class="mt-1">{{ props.item.content }}</div>
                        <div class="mt-1"><a rel="noopener" :href="props.item.link" target="_blank">Link to article</a></div>
                        <div class="mt-1">{{itemRssFeedCategories(props.item)}}</div>
                      </v-card-text>
                      <v-divider class="mt-0 px-2"></v-divider>
                      <v-layout row wrap pa-3>
                        <v-flex v-if="props.item.video" :class="{ 'xs12': true, 'md6': props.item.video && props.item.attachmentUrl, 'md12': props.item.video && !props.item.attachmentUrl}">
                          <iframe allowfullscreen style="width: 100%; height: 260px;border:0px" :src="props.item.video.embedUrl"></iframe>
                        </v-flex>
                        <v-flex v-if="props.item.attachmentUrl" :class="{ 'xs12': true, 'md6': props.item.attachmentUrl && props.item.video, 'md12': props.item.attachmentUrl && !props.item.video  }"
                          class="background-image" :style="{ 'backgroundImage': `url(${props.item.attachmentUrl})` }">
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs3 sm3>
              <v-btn icon medium @click.prevent="selectItem(props.item);assignId(props.item.id, 'emailDialog')" :disabled="props.item.approvalStatus !== 1 && props.item.approvalStatus !== 2">
                <v-icon medium>email</v-icon>
              </v-btn>

            </v-flex>
            <v-flex xs3 sm3>
              <v-btn icon @click.prevent="selectItem(props.item);assignId(props.item.id, 'dialog')" class="red--text">
                <v-icon>delete_forever</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <v-dialog v-model="emailDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Confim Email</div>
        </v-card-title>
        <v-card-text v-if="selectedItem.user">Are you sure you want to mail user <b>{{ selectedItem.user.firstname }} {{
          selectedItem.user.lastname}}</b>?</v-card-text>
        <v-card-text v-if="selectedItem.approvalStatus === 1">
          <v-checkbox v-model="notifyAllUsers" label="Would you like to notify all users of the new post?"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="emailDialog= false;emailUser(selectedItem.uid, selectedItem.approvalStatus)">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" lazy absolute max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Really delete?</div>
        </v-card-title>
        <v-card-text v-if="selectedItem.user">Are you sure you want to delete <b>{{ selectedItem.user.firstname }} {{
          selectedItem.user.lastname }}'s</b> post?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="dialog = false">No</v-btn>
          <v-btn class="blue--text darken-1" flat="flat" @click.native="deleteRow()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  import moment from 'moment'
  import SideViewChat from '@/components/chat/sideboxChat.vue'

  export default {
    watch: {
      toogleRssFeedSchedule (val) {
        this.$firebase.database().ref('allowRssFeedSchedule').set(val)
      }
    },
    computed: {
      posts () {
        return this.$store.getters.fetchFeeds
      },
      loading () {
        return this.$store.getters.getLoading
      },
      error () {
        return this.$store.getters.getError
      },
      updateProcess () {
        return this.$store.getters.getProcess === 'Settings Saved'
      },
      process () {
        return this.$store.getters.getProcess
      },
      feeds () {
        if (this.currentStatus || this.currentStatus === 0 || this.dateRange !== 0) {
          let dateAfter = moment().clone().subtract(this.dateRange, 'days').startOf('day')
          return this.posts.filter((post) => {
            if (this.currentStatus) {
              return post.approvalStatus === this.currentStatus
            }
            if (this.dateRange !== 0) {
              return moment(post.posteddate).isAfter(dateAfter)
            }
          }).sort((d1, d2) => new Date(d2.submitdate).getTime() - new Date(d1.submitdate).getTime())
        } else {
          return this.posts.sort((d1, d2) => new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime())
        }
      }
    },
    beforeMount () {
      this.$store.dispatch('fetchAllPosts')
      this.$firebase.database().ref('allowRssFeedSchedule').once('value', (snapshot) => {
        if (snapshot.exists()) {
          this.toogleRssFeedSchedule = snapshot.val() ? true : false
        }
      })
    },
    components: {
      SideViewChat
    },
    data () {
      return {
        selectedItem: {},
        emailDialog: false,
        toogleRssFeedSchedule: false,
        search: '',
        e1: '',
        currentPostId: '',
        pagination: {
          rowsPerPage: 15
        },
        notifyAllUsers: false,
        dialog: false,
        currentStatus: '',
        dateRange: 0,
        view_dialog: false,
        headers: [
          {
            text: 'Post Date',
            align: 'left',
            sortable: false,
            value: 'posteddate'
          },
          {
            text: 'User',
            value: 'user',
            align: 'left',
            sortable: false
          },
          {
            text: 'Company',
            value: 'companylegalname',
            align: 'left',
            sortable: false
          },
          {
            text: 'Content',
            value: 'content',
            align: 'left',
            sortable: false
          },
          {
            text: 'Status',
            value: 'status',
            align: 'left',
            sortable: false
          },
          {
            text: 'Actions',
            value: 'actions',
            align: 'left',
            sortable: false
          }
        ],
        status_filter: [
          {
            text: 'All',
            value: ''
          },
          {
            text: 'Approved',
            value: 1
          },
          {
            text: 'Pending',
            value: 0
          },
          {
            text: 'Rejected',
            value: 2
          }
        ],
        default_filter: [
          {
            text: 'All',
            value: 0
          },
          {
            text: 'Last 24hrs',
            value: 1
          },
          {
            text: 'Last 7 days',
            value: 7
          },
          {
            text: 'Last 30 days',
            value: 30
          }
        ],
        items: []
      }
    },
    methods: {
      itemRssFeedCategories (item) {
        var categories = []
        if (item.type && item.type === 'rss') {
          categories = item.categories.map(category => {
            return `#${category.replace(' ', '-')}`.toLowerCase()
          })
          return categories.join(' ')
        }
      },
      openChat (uid) {
        this.contactUser(uid)
        this.contactUser(uid)
      },
      contactUser (uid) {
        window.$applozic.fn.applozic('loadTab', uid)
        document.getElementsByClassName('chatbutton ')[0].click()
      },
      changeStatus (status, postId) {
        const payload = {
          type: 'posts',
          status,
          postId
        }
        this.$store.dispatch('changeStatus', payload)
      },
      selectItem (item) {
        this.selectedItem = item
      },
      emailUser (uid, approvalStatus) {
        let date = this.selectedItem.posteddate
        if (approvalStatus === 1) {
          var notifyAllUsers = this.notifyAllUsers
          this.$store.dispatch('sendMail', {uid: uid, action: 'post_approved', date})
          if (notifyAllUsers) {
            this.$store.dispatch('sendEmailToAllUsers', {postId: this.selectedItem.id, roles: [1, 4]})
          }
        } else if (approvalStatus === 2) {
          this.$store.dispatch('sendMail', {uid: uid, action: 'post_declined', date})
        }
        this.notifyAllUsers = false
      },
      returnLogo (logo) {
        if (!logo) {
          return '/static/images/default_company_logo.png'
        }
        return logo
      },
      filterStatus (status) {
        this.currentStatus = status
      },
      assignId (postId, type) {
        this.currentPostId = postId
        this[type] = true
      },
      deleteRow () {
        const payload = {
          type: 'posts',
          postId: this.currentPostId
        }
        this.$store.dispatch('deletePost', payload)
        this.dialog = false
      }
    }
  }
</script>

<style>
  .rss-feed-switch label {
    font-weight: 600 !important;
    color: #212121 !important;
  }
</style>

<style lang="scss" scoped>
  .background-image {
    background-position-y: center;
    background-size: cover;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    right: 0;
    height: 260px;
    bottom: 0;
  }
  .card__title {
    padding-bottom: 16px;
    padding-top: 16px;
    padding-left: 16px;
  }
  .activity-search {
    margin-left: auto;
  }
  .input-group .input-group__details {
    display:none;
  }
</style>



// WEBPACK FOOTER //
// activity.vue?5cb490c6